import { AnswerInput } from "../gql/gql-types";
import { CustomAnswer } from "../types/customQuestion";

import { serializeAnswer } from "./customAnswer";

export const serializeParticipantAnswers = (answers: CustomAnswer[], rateId: string): AnswerInput[] => {
  return answers?.map((answer) => ({ ...serializeAnswer(answer), rateId }));
};
